/* The submission pack. Tokens only (ADR-0007); nothing here is regime-specific. */

.group {
  margin: 0 0 14px;
}

.heading {
  margin: 0 0 6px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink);
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item {
  max-width: 92ch;
  font-size: var(--t-min);
  line-height: 1.55;
  color: var(--ink-2);
}

.item strong {
  color: var(--ink);
}

.cite {
  display: block;
  color: var(--muted);
}

.limit {
  display: block;
  color: var(--ink-2);
}

.form {
  display: grid;
  gap: 8px;
  margin-top: 8px;
  max-width: 60ch;
}

.form label {
  display: grid;
  gap: 2px;
  font-size: var(--t-min);
  color: var(--ink-2);
}

.form input[type="text"],
.form textarea {
  font: inherit;
  padding: 4px 6px;
  border: 1px solid var(--line-2);
  background: var(--panel);
  color: var(--ink);
}

.confirm {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}

.letter {
  margin: 8px 0 0;
  padding: 8px 10px;
  border-left: 2px solid var(--line-2);
  white-space: pre-wrap;
  font-size: var(--t-min);
  color: var(--ink);
  max-width: 92ch;
}

.table {
  width: 100%;
  border-collapse: collapse;
  font-size: var(--t-min);
}

.table th,
.table td {
  text-align: left;
  vertical-align: top;
  padding: 6px 8px;
  border-bottom: 1px solid var(--line);
}

.table th {
  color: var(--muted);
  font-weight: 600;
}

.question {
  display: block;
  color: var(--muted);
}

.value {
  font-variant-numeric: lining-nums tabular-nums;
  color: var(--ink);
}

.theirs {
  color: var(--muted);
}

.section {
  margin: 12px 0 4px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--ink);
}
